"use client";

import { PlayIcon } from "@heroicons/react/24/solid";
import Image from "next/image";
import { useState } from "react";
import YouTube, { YouTubeProps } from "react-youtube";

import { VideoReviewType } from "@/types/types";
import { getSizesString } from "@/utils/getSizesString";

export function VideoReview({ videoReview }: { videoReview: VideoReviewType }) {
  const [videoOpen, setVideoOpen] = useState(false);

  const opts: YouTubeProps["opts"] = {
    height: "100%",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      rel: 0,
    },
  };

  return (
    <div className="aspect-h-9 aspect-w-16 relative w-full">
      {videoOpen ?
        <YouTube videoId={videoReview.youtubeVideoId} opts={opts} />
      : <>
          <Image
            src={videoReview.image}
            alt={videoReview.imageAlt}
            className="rounded-3xl object-cover"
            fill={true}
            sizes={getSizesString({
              sm: 100,
              md: 100,
              lg: 50,
              rest: 50,
            })}
          />
          <button
            onClick={() => setVideoOpen(true)}
            className="group absolute inset-0 flex items-center justify-center rounded-3xl"
          >
            <PlayIcon className="box-content h-8 w-8 rounded-full bg-gray-900 bg-opacity-80 fill-white p-4 transition-colors group-hover:bg-opacity-50" />
          </button>
        </>
      }
    </div>
  );
}
